const updateFormFieldKey = (field, key, value) => Object.assign({}, field, {
  [key]: value
});
export default updateFormFieldKey;